module.exports = __webpack_public_path__ + "img/login-arrow.ac39012e.svg";